module.exports = __webpack_public_path__ + "static/media/mobile-img.b85126e6.svg";